<template>
  <div class="col-12 row m-0 p-0">
    <div class="col-12 col-md-6 row m-0 justify-content-center mt-5" v-for="(item, index) in items" :key="index"
      style="height: 250px">
      <img :src="$Img.url + item.LOGO" :alt="item.SuplNM" class="cust_card" @click="showRestaurantDetail(item)" />
      <div class="col-12">
        <label class="m-0" style="color: #9b7f7f; font-size: 1.5rem">{{
          item.SuplNM
        }}</label>
      </div>
    </div>
    <div class="col-12 col-md-6 d-flex justify-content-center" v-if="items.length % 2 == 1"></div>
    <b-modal ref="RestaurantDetail" :title="selectedRestaurant.SuplNM" hide-footer hide-header centered no-fade
      no-close-on-backdrop no-close-on-esc size="lg">
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hideRestaurantDetail"></b-icon>
      </div>
      <div class="col-12 row m-0 mb-2" style="border-bottom: 1px solid #9b7f7f;">
        <label class="m-0" style="font-size: 2rem; color: #ec6c01">{{
          selectedRestaurant.SuplNM
        }}</label>
      </div>
      <div class="col-12 row m-0 mb-2">
        <img v-if="selectedRestaurant.LOGO != undefined" style="max-width: 100%; max-height: 100%;"
          :src="$Img.url + selectedRestaurant.LOGO" :alt="selectedRestaurant.SuplNM">
        <label class="m-0" style="font-size: 1.5rem;">{{
          selectedRestaurant.Notes
        }}</label>
      </div>
      <div class="col-12 row m-0 justify-content-around mt-4">
        <b-button style="border: 0; background-color: #e58a37; width: 45%;font-size: 1.5rem;" @click="GoWEB"
          :disabled="selectedRestaurant.Link_restaurant == '' || selectedRestaurant.Link_restaurant == null || selectedRestaurant.Link_restaurant == undefined">網站</b-button>
        <b-button style="border: 0; background-color: #e58a37; width: 45%;font-size: 1.5rem;" @click="GoReservation"
          :disabled="selectedRestaurant.Link_reservation == '' || selectedRestaurant.Link_reservation == null || selectedRestaurant.Link_reservation == undefined">訂位</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      items: [],
      selectedRestaurant: [],
      IS_ON_FIRST_PAGE: false
    };
  },
  watch: {},
  mounted() {
    //this.calcTotalPage();
    this.GetSupl();
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    GoAction(item) {
      if (item.Link_restaurant != '' && item.Link_restaurant != null && item.Link_restaurant != undefined) {
        window.open(item.Link_restaurant);
      }
      else {
        this.$router.push({
          name: 'OrderOrReservation',
          query: {
            value: this.$Global.Base64Utils.utoa(JSON.stringify(item.SuplNO))
          }
        });
      }
    },
    GoWEB() {
      if (this.selectedRestaurant.Link_restaurant != '' && this.selectedRestaurant.Link_restaurant != null && this.selectedRestaurant.Link_restaurant != undefined) {
        window.open(this.selectedRestaurant.Link_restaurant);
      }
    },
    GoReservation() {
      if (this.selectedRestaurant.Link_reservation != '' && this.selectedRestaurant.Link_reservation != null && this.selectedRestaurant.Link_reservation != undefined) {
        window.open(this.selectedRestaurant.Link_reservation);
      }
    },
    async GetSupl() {
      this.items = await this.$Global.GetSuplList(
        '餐廳',
        this.$cookieFunc.getCookie('Userid'),
        this.$cookieFunc.getCookie('ShopNO')
      );
      //console.log(this.items);
    },
    showRestaurantDetail(data) {
      this.selectedRestaurant = data;
      this.$refs.RestaurantDetail.show();
    },
    hideRestaurantDetail() {
      this.selectedRestaurant = [];
      this.$refs.RestaurantDetail.hide();
    }
  }
};
</script>
<style scoped>
.event_count_label_g {
  border-radius: 6px;
  margin: 0 !important;
  font-size: 1rem;
  background-color: #69a835;
  color: white;
  font-weight: 600;
  padding: 2px 8px 2px 8px;
}

.event_count_label_r {
  border-radius: 6px;
  margin: 0 !important;
  font-size: 1rem;
  background-color: #c62e67;
  color: white;
  font-weight: 600;
  padding: 2px 8px 2px 8px;
}

.event_label {
  margin-left: 10px !important;
  font-size: 1.5rem;
  color: #a37e5c;
  font-weight: 600;
}

.Main_css {
  background-color: #faf7f2;
}

.cust_card_icon {
  width: 65px;
  height: 65px;
}

.cust_card {
  /* padding: 15px 50px 15px 50px; */
  /* border: 1px solid white; */
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  height: 200px;
  width: 100%;
  max-width: 400px;
  cursor: pointer;
}

.cust_page_btn {
  height: 45px;
  width: 30px;
  padding: 0;
  justify-content: center;
  background-color: #ec6c01;
  border: #ec6c01;
}

.cust_sec_head {
  background: linear-gradient(to right, #fcedd0, white);
}

.cust_sec_head_label {
  font-size: 1.25rem;
  color: #a37e5c;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Meal/Restaurant.vue